/**
 * 统一处理api请求
 */
import axios from 'axios';
import { Toast, Dialog } from 'vant';
import qs from 'querystring';
import { getQueryString } from './tools.js';
import { checkCode } from './checkCode.js';
import { jsonp } from 'vue-jsonp';

Toast.allowMultiple();
/**
 * 检查 请求状态码
 * @param {Object} response axios response 返回对象
 * @returns {Object} 返回数据 response.data
 */
const checkStatus = response => {
  const { status, data } = response;
  let newData;
  if (response) {
    switch (status) {
      case 200:
      case 304:
        newData = data;
        break;
      case 400:
      case 404:
      case 500:
      case 502:
      case 503:
      case 504:
      case 505:
      default:
        // newData = {
        //   err_code: -1,
        //   err_msg: '未知错误，请稍候尝试'
        // };
        console.log('未知错误', response);
        break;
    }
    return newData;
  }
  // 异常状态
  return {
    err_code: -4,
    err_msg: '网络异常，请稍候重新尝试'
  };
};

const instance = axios.create({
  timeout: 50000
});

// POST传参序列化(添加请求拦截器)
// eslint-disable-next-line arrow-body-style
instance.interceptors.request.use(
  config => {
    return config;
  },
  error => Promise.reject(error)
);
// 返回状态判断(添加响应拦截器)
instance.interceptors.response.use(
  response => checkStatus(response),
  error => {
    if (!error.response) {
      return checkStatus({ status: 502 });
    }
    return checkStatus(error.response);
  }
);

let host = window.location.origin; //不同分店的地址要改为相应的域名
let appid = window.location.host.split('.')[0]; // 'wxa4d8ba64ab6b8178.mp.weixinhost.com'
if (process.env.NODE_ENV === 'development') {
  host = getQueryString('mock') == 1 ? 'https://mock.maizs.top/mock/62285368dde3c458083d8ac5' : '',
  appid = 'wxa4d8ba64ab6b8178';
}

const scriptCache = {};
export const loadScript = (url, nocache = false) => {
  return new Promise(function(resolve, reject) {
    if (scriptCache[url] && !nocache) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
      //IE
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          scriptCache[url] = true;
          resolve();
        }
      };
    } else {
      //Others: Firefox, Safari, Chrome, and Opera
      script.onload = function() {
        scriptCache[url] = true;
        resolve();
      };
    }
    script.src = url;
    document.body.appendChild(script);
  });
};

const getUrl = url => {
  if (getQueryString('mock') == 1) {
    return `${host}/addon/app-commonapply/${url}`
  }
  return `${host}/addon/app-commonapply/api/${url}`;
};

// 【待修改配置】
export const getToken = () => {
  if (getQueryString('mock') == 1) {
    return 'testtoken';
  }
  return localStorage.getItem('FORM_TOKEN') || '';
};

// token接口白名单（不需要待token的）
const whiteApiList = [
  'get_form_config',
  'check_sms_quota',
  'get_preview_form_detail'
];

class API {
  constructor() {
    this.get = (url, params = {}, notips) => {
      const loading = Toast.loading({
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
        className: 'fetch-loading'
      });
      const p = {
        ...params,
        token: getToken()
      }
      if (whiteApiList.indexOf(url) >= 0) {
        delete p.token;
      }
      return instance
        .get(getUrl(url), {
          params: p
        })
        .then((res) => {
          return checkCode({
            res: res, 
            method: 'get',
            url: url, 
            params: p,
            notips: notips
          });
        }).finally(() => {
          loading.clear();
        });
    }
      
    this.post = (url, body = {}, notips) => {
      const loading = Toast.loading({
        message: null,
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
        className: 'fetch-loading'
      });
      const p = body instanceof FormData ? body : {
        ...body,
      };
      let _url = getUrl(url);
      if (whiteApiList.indexOf(url) >= 0) {
        delete p.token;
      } else {
        _url = `${_url}?token=${getToken()}`;
      }
      return instance
        .post(_url, p)
        .then((res) => {
          return checkCode({
            res: res, 
            method: 'post',
            url: url, 
            params: p,
            notips: notips
          });
        }).finally(() => {
          loading.clear();
        })
    }

    this.axios = axios;
  }
  ViewForm(params) {
    return this.get('view_form', params);
  }

  CheckSmsQuota(params) {
    return this.get('check_sms_quota', params);
  }

  GetFormConfig(params) {
    return this.get('get_form_config', params);
  }

  GetFormFields(params) {
    return this.get('get_form_fields', params);
  }

  GetPreviewFormDetail(params) {
    return this.get('get_preview_form_detail', params);
  }

  Submit(body) {
    return this.post('submit', body);
  }
  Modify(body) {
    return this.post('modify', body);
  }

  SendVerifyCode(body) {
    return this.post('send_verify_code', body);
  }

  Verify(body) {
    return this.post('verify', body);
  }

  CheckSubmit(params, notips) {
    return this.get('check_submit', params, notips);
  }

  Check(body) {
    return this.post('check', body);
  }

  CountFormSubmitField(body, notips) {
    return this.post('count_form_submit_field', body, notips);
  }

  GetSubmitDetail(params, notips) {
    return this.get('get_submit_detail', params, notips);
  }

  GetSubmitList(params, notips) {
    return this.get('get_submit_list', params, notips);
  }

  GetGeocoder({ latitude, logitude }) {
    const api = `https://apis.map.qq.com/ws/geocoder/v1/`;
    const query = {
      key: 'ILWBZ-3AX63-OGK3U-3F2J3-FFDV6-N2FAP',
      callbackName: 'WeChatMap',
      output: 'jsonp',
      location: latitude + ',' + logitude
    }
    return jsonp(api, query);
  }
  
  // 微信jssdk
  WxJsSign(body) {
    const api = `/addon/weixin_web_dev_tools?a=get_jsticket`;
    body = {
      ...body,
      appid: appid
    };
    return instance
      .post(api, qs.stringify(body), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      })
      .finally(() => {
      });
  }

  UploadImage(formData) {
    formData.append('appid', appid);
    const api = `/addon/weixin_web_dev_tools?a=upload_image`;
    return instance
      .post(api, formData, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      })
      .then((res) => {
        return checkCode({
          res: res, 
          method: 'post',
          url: api, 
          params: {}
        });
      })
      .finally(() => {
      });
  }

  /* 如果希望用首屏加载时间换取页面交互的流畅，可以使用以下方式进行资源预加载处理 */
  // 预加载资源
  GetRes(path) {
    return instance.get(path, {});
  }

  // 预加载图片
  LoadImg(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = function() {
        resolve();
      };
      img.onerror = function() {
        resolve();
      };
    });
  }

  // 批量预加载图片
  PreLoadResource(res) {
    return Promise.all(res.map((item) => {
      return this.LoadImg(item);
    }));
  }
}

export const api = new API();

let inAuth = 0;
export const gotoauth = () => {
  if (inAuth) {
    return;
  }
  const authnum = window.parseInt(window.localStorage.getItem('APP_AUTH')) || 0;
  if (authnum < 3) {
    window.localStorage.setItem('APP_AUTH', authnum + 1);
    const authUrl = `${window.location.origin}/addon/app-commonapply/wechat_auth?redirect=${encodeURIComponent(window.location.href)}`;
    inAuth = 1;
    console.log(authUrl);
    window.location.replace(authUrl);
    
  } else {
    window.localStorage.setItem('APP_AUTH', 0);
    Dialog.alert({
      title: '系统提示',
      message: '授权失败，请刷新页面重新尝试授权',
      confirmButtonText: '知道了'
    }).then(() => {
    });
    if (Toast?.close) {
      Toast.close();
    }
  }
};